import React, { Component, Fragment } from 'react';
import AnimateHeight from 'react-animate-height';
import { compose } from 'redux';
import { connect } from 'react-redux';
import ModalDecorator from 'hocs/ModalDecorator';
import Avatar from 'components/Avatar/Avatar';
import { $ } from 'rype-bootstrap';
import { browserHistory, Link } from 'react-router';
import moment from 'moment';
import { skipRating, submitRating } from 'actions/ratingActions';
import { selectDay } from 'actions/filterActions';
import { CSSTransitionGroup } from 'react-transition-group';

import Rater from 'react-rater';
import 'react-rater/lib/react-rater.css';

import './style.css';

class ConfirmLessonModal extends Component {
  constructor() {
    super();

    this.state = {
      rating: null,
      feedback: '',
      error: null,
      submitting: null,
      success: false,
      actionSuccesful: false,
    };

    $.noConflict();
  }

  componentDidMount() {
    // the HOC ModalDecorator adds and removes this modal from the DOM.
    //
    // once the component mounts, we need to manually add call show
    // to force Bootstrap to render the modal
    //
    // the delay is present to smooth the transitions
    // while the component continues to load
    setTimeout(() => $('#confirm-lesson-modal').modal('show'), 75);

    // set up an event listener to call this.props.closeModal
    // whenever the modal is hidden.
    // closeModal comes from ModalDecorator, and causes
    // the element to be removed from the DOM
    $('#confirm-lesson-modal').on('hidden.bs.modal', () => {
      this.props.closeModal();
    });

    const { appointment } = this.props.modalProps;
    this.setState({
      rating: appointment.rating,
      feedback: appointment.feedback || '',
    });
  }

  componentWillUnmount() {
    const { appointment, onSkipRating } = this.props.modalProps;
    if (
      !appointment.ratedAt &&
      !appointment.ratingSkippedAt &&
      !this.state.actionSuccesful
    ) {
      this.submitSkipRating();
      onSkipRating && onSkipRating();
    }
  }

  close = () => {
    // Call 'hide' to reset all the Bootstrap styling
    $('#confirm-lesson-modal').modal('hide');
  };

  handleFeedbackChange = (event) => {
    this.setState({ feedback: event.target.value });
  };

  sendToReportIssue = () => {
    const { appointment } = this.props.modalProps;
    this.close();
    window.location.href = appointment ?
      `/report-problem?aid=${appointment.id}` :
      '/report-problem';
  };

  requestRefund = () => {
    this.submitRating(this.sendToReportIssue, this.sendToReportIssue);
  };

  skipRating = () => {
    const { onSkipRating } = this.props.modalProps;
    this.setState({ submitting: true, error: null });
    this.submitSkipRating(
      () => {
        this.setState({ actionSuccesful: true });
        this.close();
        onSkipRating && onSkipRating();
      },
      (response) => {
        const errorMessage =
          response.message || 'An unknown error has occurred';
        this.setState({ error: errorMessage, submitting: false });
        setTimeout(this.close, 1000);
      }
    );
  };

  submitSkipRating = (success, failure) => {
    const { appointment } = this.props.modalProps;
    this.props.skipRating(
      appointment.id,
      () => {
        success && success();
      },
      (response) => {
        failure && failure(response);
      }
    );
  };

  bookAnotherLesson = () => {
    const { appointment } = this.props.modalProps;
    const tomorrow = moment().add(1, 'day');
    this.props.selectDay(tomorrow);
    browserHistory.push(`/schedule-lesson/${appointment.teacher.slug}`);
    this.close();
  };

  submit = () => {
    this.submitRating();
  };

  submitRating(success, failure) {
    const { appointment, onRatingComplete, trialStatus } = this.props.modalProps;
    const { rating } = this.state;
    let { feedback } = this.state;
    if (feedback.trim() === '') feedback = null;
    this.setState({ submitting: true, error: null });
    this.props.submitRating(
      appointment.id,
      { rating, feedback },
      () => {
        this.setState({ actionSuccesful: true });
        if (success) {
          success();
        } else {
          onRatingComplete && onRatingComplete();
          this.setState({ success: true });
          if (trialStatus.status === 'credit_trial') {
            setTimeout(this.close, 1000);
          }
        }
      },
      (response) => {
        if (failure) {
          failure();
        } else {
          const errorMessage =
            response.message || 'An unknown error has occurred';
          this.setState({ error: errorMessage, submitting: false });
        }
      }
    );
  }

  renderBadLessonApology() {
    return (
      <Fragment>
        <div className="mt-2">
          <strong>We're sorry your lesson wasn't amazing.</strong>
        </div>
        <div className="request-refund mt-2">
          <Link onClick={this.requestRefund}>Request a refund</Link>
        </div>
      </Fragment>
    );
  }

  renderConfirmLessonModalBody() {
    const { appointment, skipDisabled, trialStatus } = this.props.modalProps;
    const startTime = moment(appointment.startTime).format(
      'MMM DD, YYYY h:mma'
    );
    const showSkip = !skipDisabled && this.state.rating === null;

    if (this.state.success && trialStatus.status === 'not_on_trial') {
      return (
        <div className="modal-body text-center">
          <CSSTransitionGroup
            transitionName="bookNextLesson"
            transitionAppear
            transitionEnter={false}
            transitionLeave
            transitionAppearTimeout={300}
            transitionLeaveTimeout={500}
          >
            <Avatar
              className="d-inline-block"
              imageClassName="avatar"
              src={appointment.teacher.imageUrl}
              alt={appointment.teacher.name}
            />
            <h4 className="mt-2">
              {' '}
              Want to book another lesson with {appointment.teacher.name}?
            </h4>

            <div className="mt-4 text-center">
              <button
                type="button"
                className="btn btn-primary btn-lg btn-cursor w-100 mb-3"
                onClick={this.bookAnotherLesson}
              >
                Book Another Lesson
              </button>
            </div>

            <div className="my-2 exit-zone">
              <Link onClick={this.close}>Not right now</Link>
            </div>
          </CSSTransitionGroup>
        </div>
      );
    }

    return (
      <div className="modal-body text-center">
        <Avatar
          className="d-inline-block"
          imageClassName="avatar"
          src={appointment.teacher.imageUrl}
          alt={appointment.teacher.name}
        />
        <h4 className="mt-2">
          {' '}
          How was your lesson with {appointment.teacher.name}?
        </h4>
        <div>{startTime}</div>

        <Rater
          total={5}
          rating={this.state.rating}
          interactive
          onRate={(e) => {
            this.setState({ rating: e.rating, error: null });
          }}
        />

        <AnimateHeight
          duration={250}
          height={
            this.state.rating !== null && this.state.rating < 4 ?
              'auto' :
              0
          }
        >
          <Fragment>{this.renderBadLessonApology()}</Fragment>
        </AnimateHeight>

        <AnimateHeight
          duration={250}
          height={
            this.state.rating !== null && this.state.rating <= 4 ?
              'auto' :
              0
          }
        >
          <textarea
            value={this.state.feedback}
            className="mt-4 form-control"
            id="textarea"
            rows="6"
            placeholder="How could your lesson have been better? (optional)"
            onChange={this.handleFeedbackChange}
          />
        </AnimateHeight>

        <div className="mt-4 text-center">
          <button
            type="button"
            className="btn btn-primary btn-lg btn-cursor w-100"
            onClick={this.submit}
            disabled={this.state.rating === null || this.state.submitting}
          >
            Submit
          </button>
        </div>

        <div className="mt-4 exit-zone">
          {showSkip && (
            <Link
              disabled={this.state.submitting}
              onClick={this.skipRating}
            >
              Skip
            </Link>
          )}
          {!showSkip && <Link onClick={this.close}>Close</Link>}
        </div>

        <div className="status-container mt-2">
          <div
            className={
              this.state.error ?
                'text-danger' :
                this.state.success ?
                  'text-success' :
                  null
            }
          >
            {this.state.error ?
              this.state.error :
              this.state.success ?
                'Thank you!' :
                null}
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div
        id="confirm-lesson-modal"
        className="ConfirmLessonModal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="confirm-lesson-label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            {this.renderConfirmLessonModalBody()}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    modalProps: state.visibleModal.props,
  };
}

export default compose(
  ModalDecorator('confirm-lesson-modal'),
  connect(mapStateToProps, {
    selectDay,
    skipRating,
    submitRating,
  })
)(ConfirmLessonModal);



// WEBPACK FOOTER //
// ./src/components/modals/ConfirmLessonModal/index.js